import React from 'react'
import logo from '../assets/images/zappy-logo.png'
import { Popover } from 'antd'
import { MailOutlined } from '@ant-design/icons'
import { ReactComponent as Headset } from '../assets/svg/headset.svg'

const content = (
  <div className="flex flex-col items-center">
    <span>Hai bisogno di aiuto?</span>
    <div className="flex w-full flex-col items-center my-2">
      <Headset width={35} height={35} />
      <span>Contatta il servizio clienti</span>
      <a href="tel:+390294755452" className="text-primary">
        +39 02 9475 5452
      </a>
      <div style={{
        fontSize:"80%"
      }}>lunedì - venerdì / h. 9:30 - 12:30, 
      14:30 - 17:30</div>
    </div>
    <div className="flex w-full flex-col items-center my-2">
      <MailOutlined className="text-3xl" />
      <span>Invia un messagio</span>
      <a href="https://www.zappyrent.com/it/help" className="text-primary">
        Zappyrent Helpdesk
      </a>
    </div>
  </div>
)

const Header = () => {
  return (
    <div className="flex w-full justify-between items-center px-2 md:px-8">
      <div
        className="w-3/6 md:w-3/6"
        style={{
          maxWidth: '8rem',
        }}
      >
        <a href={process.env.REACT_APP_WEBSITE_PATH}>
          <img src={logo} />
        </a>
      </div>
      <div className="relative">
        <Popover placement="topRight" content={content}>
          <input
            type="button"
            className="font-bold cursor-pointer outline-none bg-white"
            value="Serve aiuto?"
          />
        </Popover>
      </div>
    </div>
  )
}

export default Header
